import React, {FC, useEffect, useState} from 'react';

import LoginForm from '@/components/Login/LoginForm';

import i18n from 'i18next';

import login from '@/domain/useCases/login';

import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {isAuthenticated} from '@/domain/services/authService';

const LoginView: FC = () => {
  
  const navigate = useNavigate();
  const {t} = useTranslation();

  const [user, setUsername] = useState('');
  const [pass, setPassword] = useState('');
  const [errors, setErrors] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    isAuthenticated()
      .then((isLogged) => isLogged ? navigate(`/${i18n.resolvedLanguage}/`) : undefined)
      .catch((error) => {
        console.error('Error checking login status:', error);
      });
  }, [navigate]);

  const handleLogin = async () => {
    setErrors('');
    setIsLoading(true);

    try {
      const result = await login(user, pass, t);

      if (result) {
        // Si result existe, es un LoginError
        setErrors(result.detail);
      } else {
        // Login exitoso
        navigate(`/${i18n.resolvedLanguage}/`);
      }
    } catch (error) {
      // Capturar errores no controlados (problemas de red, etc.)
      console.error('Login error:', error);

      // Si el error tiene la estructura {statusCode, payload: {detail}}
      if (error && typeof error === 'object' && 'payload' in error) {
        const errorWithPayload = error as {payload: {detail: string}};
        setErrors(errorWithPayload.payload.detail);
      } else if (error && typeof error === 'object' && 'detail' in error) {
        const errorWithDetail = error as {detail: string};
        setErrors(errorWithDetail.detail);
      } else if (error instanceof Error) {
        setErrors(error.message);
      } else {
        setErrors('Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return <LoginForm
    password={pass}
    username={user}
    loginErrorMessage={errors}
    isLoading={isLoading}
    onLoginButtonClicked={handleLogin}
    onPasswordChanged={setPassword}
    onUsernameChanged={setUsername}
  />;
};

export default LoginView;